import { render, staticRenderFns } from "./LessonFeaturedAsset.vue?vue&type=template&id=bb323306"
import script from "./LessonFeaturedAsset.vue?vue&type=script&lang=js"
export * from "./LessonFeaturedAsset.vue?vue&type=script&lang=js"
import style0 from "./LessonFeaturedAsset.vue?vue&type=style&index=0&id=bb323306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports